'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DashedLabel(_ref) {
  var children = _ref.children,
      transparent = _ref.transparent;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classNames2.default)('m-y-6 dashed-label', {
        'justify-center': transparent
      })
    },
    !transparent && _react2.default.createElement('div', { className: 'border-line-left' }),
    _react2.default.createElement(
      'div',
      { className: 'closed-text p-x-4' },
      _react2.default.createElement(
        'p',
        { className: 'm-bottom-0 text-center' },
        _react2.default.createElement(
          _Small2.default,
          { className: 'divider-text align-center', use: 'help' },
          children
        )
      )
    ),
    !transparent && _react2.default.createElement('div', { className: 'border-line-right' })
  );
}

DashedLabel.propTypes = {
  children: _react.PropTypes.node.isRequired,
  transparent: _react.PropTypes.bool
};

exports.default = DashedLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/label/DashedLabel.js
// module id = 1145
// module chunks = 2 3